import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { CronExprFormField } from './formFields/CronExprFormField';

export const SchedForm = () => {
  
  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.cronExpr.component = <CronExprFormField key="cronExpr" fieldDef={fieldToFieldDef.cronExpr}/>;
  }

  return (
    <EntityForm augFieldDefs={augFieldDefs} />
  )
}